const CHANNEL_NAME = 'omicon-notification-sync';
const TAB_ID = Math.random().toString(36).slice(2);
const isSupported = typeof BroadcastChannel !== 'undefined';
const postChannel = isSupported ? new BroadcastChannel(CHANNEL_NAME) : null;

// Call only after the read/clear API succeeded. Pass includeSelf=false when this tab's state is already updated.
export const postNotifSync = (includeSelf = true) => {
    postChannel?.postMessage({ tabId: TAB_ID, includeSelf });
};

// Returns an unsubscribe function.
export const subscribeNotifSync = (callback) => {
    if (!isSupported) return () => { };
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = ({ data }) => {
        if (data?.includeSelf || data?.tabId !== TAB_ID) callback();
    };
    return () => channel.close();
};
